import React from 'react';
import EspecialidadCard from './EspecialidadCard';
import './Especialidades.css';
import Implantologia from '../assets/images/Implantología.jpg';
import Rehabilitacion from '../assets/images/rehabilitacion.jpg';
import DisenoSonrisa from '../assets/images/sonrisa.jpg';
const Especialidades = ({ variant }) => {
  const especialidades = [
    {
      title: 'Implantología Bucomaxilofacial - Implante dental',
      image: Implantologia,
      altText: 'Implantología',
    },
    {
      title: 'Rehabilitación Oral',
      image: Rehabilitacion,
      altText: 'Rehabilitación',
    },
    {
      title: 'Diseño de Sonrisa',
      image: DisenoSonrisa,
      altText: 'Sonrisa',
    },
  ];

  return (
    <section className={`especialidades ${variant}`}>
      <h2>Especialidades</h2>
      <div className="especialidades-content">
        {especialidades.map((especialidad, index) => (
          <EspecialidadCard
            key={index}
            title={especialidad.title}
            image={especialidad.image}
            altText={especialidad.altText}
          />
        ))}
      </div>
    </section>
  );
};

export default Especialidades; 